const forge = require("node-forge");

export function generateRsaKeyPair() {
  // https://www.adobe.io/authentication/auth-methods.html#!AdobeDocs/adobeio-auth/master/JWT/JWTCertificate.md
  // openssl req -x509 -sha256 -nodes -days 365 -newkey rsa:2048 -keyout private.key -out certificate_pub.crt
  try {
    const rsaKeys = {};
    const pki = forge.pki;
    const keys = pki.rsa.generateKeyPair(2048);
    const cert = pki.createCertificate();
    cert.publicKey = keys.publicKey;
    cert.serialNumber = "01";
    cert.validity.notBefore = new Date();
    cert.validity.notAfter = new Date();
    cert.validity.notAfter.setFullYear(
      cert.validity.notBefore.getFullYear() + 99
    );
    const attrs = [
      {
        name: "commonName",
        value: "Adobe",
      },
      {
        name: "countryName",
        value: "US",
      },
      {
        shortName: "ST",
        value: "Adobe",
      },
      {
        name: "localityName",
        value: "Adobe",
      },
      {
        name: "organizationName",
        value: "Adobe",
      },
      {
        shortName: "OU",
        value: "Adobe",
      },
    ];
    cert.setSubject(attrs);
    cert.setIssuer(attrs);
    cert.setExtensions([
      {
        name: "basicConstraints",
        cA: true,
      },
      {
        name: "keyUsage",
        keyCertSign: true,
        digitalSignature: true,
        nonRepudiation: true,
        keyEncipherment: true,
        dataEncipherment: true,
      },
      {
        name: "extKeyUsage",
        serverAuth: true,
        clientAuth: true,
        codeSigning: true,
        emailProtection: true,
        timeStamping: true,
      },
      {
        name: "nsCertType",
        client: true,
        server: true,
        email: true,
        objsign: true,
        sslCA: true,
        emailCA: true,
        objCA: true,
      },
      {
        name: "subjectAltName",
        altNames: [
          {
            type: 6, // URI
            value: "http://adobe.io/",
          },
          {
            type: 7, // IP
            ip: "127.0.0.1",
          },
        ],
      },
      {
        name: "subjectKeyIdentifier",
      },
    ]);
    // self-sign certificate
    // cert.sign(keys.privateKey)
    // signs a certificate using SHA-256 instead of SHA-1
    cert.sign(keys.privateKey, forge.md.sha256.create());
    // convert a Forge certificate to PEM
    const pem = pki.certificateToPem(cert);
    const publicCertFileBlob = new Blob([pem], { type: "text/plain" });
    rsaKeys.publicCertFile = new File(
      [publicCertFileBlob],
      "publicCertificate.pem",
      undefined
    );
    rsaKeys.privateKey = pki.privateKeyToPem(keys.privateKey);
    return rsaKeys;
  } catch (e) {
    return e;
  }
}

export function replacerFunc() {
  const visited = new WeakSet();
  return (key, value) => {
    if (typeof value === "object" && value !== null) {
      if (visited.has(value)) {
        return;
      }
      visited.add(value);
    }
    return value;
  };
}
